import { Box, Container, Typography } from "@mui/material";
import { LANDING_LAYOUT } from "../theme";

export const sectionSx = {
  py: { xs: 6.5, sm: 8, md: 9, lg: 10 },
  scrollMarginTop: 84
};

export function PageContainer({ children, sx = {}, ...props }) {
  return (
    <Container
      maxWidth={false}
      sx={{ maxWidth: LANDING_LAYOUT.maxWidth, px: { xs: 2, sm: 3 }, ...sx }}
      {...props}
    >
      {children}
    </Container>
  );
}

export function SectionHeading({ eyebrow, title, description }) {
  return (
    <Box
      sx={{
        maxWidth: 700,
        mb: { xs: 4.5, sm: 5.5, md: 7 },
        mx: "auto",
        textAlign: "center"
      }}
    >
      {eyebrow && (
        <Typography
          color="primary.main"
          sx={{ fontSize: 12, fontWeight: 600, letterSpacing: "0.12em", mb: 1.5 }}
        >
          {eyebrow.toUpperCase()}
        </Typography>
      )}
      {title && (
        <Typography
          component="h2"
          variant="h2"
          sx={{
            fontSize: { xs: 24, sm: 27, md: 30 },
            fontWeight: 600,
            letterSpacing: "-0.015em",
            lineHeight: 1.3
          }}
        >
          {title}
        </Typography>
      )}
      {description && (
        <Typography
          color="text.secondary"
          sx={{ fontSize: { xs: 15, sm: 16 }, lineHeight: 1.7, mt: 2 }}
        >
          {description}
        </Typography>
      )}
    </Box>
  );
}
